/**
 * errorの型が未確定の可能性がある時に
 * Errorオブジェクトであればname, message, stackをJSON化して返し、
 * それ以外はそのままJSON化して返す
 *
 * @param error
 */
export const errorToString = (error: any) =>
  error instanceof Error
    ? JSON.stringify(
        {
          name: error.name,
          message: error.message,
          stack: error.stack,
        },
        null,
        2
      )
    : JSON.stringify(error, null, 2)
